import { create } from "zustand"

type State = {
  isDisconnecting: boolean
}

type Actions = {
  setIsDisconnecting: (value: boolean) => void
}

type Store = State & Actions

export const useDisconnectingStore = create<Store>()((set) => ({
  isDisconnecting: false,
  setIsDisconnecting: (value: boolean) => {
    set({ isDisconnecting: value })
  },
}))
